__turbopack_context__.v({
  "acceptedAmount": "offer-dialog-module__ayutrW__acceptedAmount",
  "amountInput": "offer-dialog-module__ayutrW__amountInput",
  "amountLabelRow": "offer-dialog-module__ayutrW__amountLabelRow",
  "amountPresets": "offer-dialog-module__ayutrW__amountPresets",
  "amountRow": "offer-dialog-module__ayutrW__amountRow",
  "amountTools": "offer-dialog-module__ayutrW__amountTools",
  "batch-sheen": "offer-dialog-module__ayutrW__batch-sheen",
  "batchBar": "offer-dialog-module__ayutrW__batchBar",
  "batchCount": "offer-dialog-module__ayutrW__batchCount",
  "batchHead": "offer-dialog-module__ayutrW__batchHead",
  "batchProgress": "offer-dialog-module__ayutrW__batchProgress",
  "batchStep": "offer-dialog-module__ayutrW__batchStep",
  "bidDialog": "offer-dialog-module__ayutrW__bidDialog",
  "bidHeaderMain": "offer-dialog-module__ayutrW__bidHeaderMain",
  "bidIdentity": "offer-dialog-module__ayutrW__bidIdentity",
  "bidSummary": "offer-dialog-module__ayutrW__bidSummary",
  "bitcoin": "offer-dialog-module__ayutrW__bitcoin",
  "body": "offer-dialog-module__ayutrW__body",
  "breakdown": "offer-dialog-module__ayutrW__breakdown",
  "buyAction": "offer-dialog-module__ayutrW__buyAction",
  "cancel": "offer-dialog-module__ayutrW__cancel",
  "cancelOfferButton": "offer-dialog-module__ayutrW__cancelOfferButton",
  "close": "offer-dialog-module__ayutrW__close",
  "collectionName": "offer-dialog-module__ayutrW__collectionName",
  "collectionRow": "offer-dialog-module__ayutrW__collectionRow",
  "compactDialog": "offer-dialog-module__ayutrW__compactDialog",
  "currencyHelp": "offer-dialog-module__ayutrW__currencyHelp",
  "currencyInput": "offer-dialog-module__ayutrW__currencyInput",
  "currencyPrefix": "offer-dialog-module__ayutrW__currencyPrefix",
  "customFeeToggle": "offer-dialog-module__ayutrW__customFeeToggle",
  "declineSuccess": "offer-dialog-module__ayutrW__declineSuccess",
  "dialog": "offer-dialog-module__ayutrW__dialog",
  "discountConfirm": "offer-dialog-module__ayutrW__discountConfirm",
  "discountConfirmText": "offer-dialog-module__ayutrW__discountConfirmText",
  "error": "offer-dialog-module__ayutrW__error",
  "feeContent": "offer-dialog-module__ayutrW__feeContent",
  "feeDetails": "offer-dialog-module__ayutrW__feeDetails",
  "fields": "offer-dialog-module__ayutrW__fields",
  "footer": "offer-dialog-module__ayutrW__footer",
  "form": "offer-dialog-module__ayutrW__form",
  "fundingCard": "offer-dialog-module__ayutrW__fundingCard",
  "header": "offer-dialog-module__ayutrW__header",
  "headerWithAccessory": "offer-dialog-module__ayutrW__headerWithAccessory",
  "headerWithCollection": "offer-dialog-module__ayutrW__headerWithCollection",
  "headerWithoutDivider": "offer-dialog-module__ayutrW__headerWithoutDivider",
  "hint": "offer-dialog-module__ayutrW__hint",
  "inboxCard": "offer-dialog-module__ayutrW__inboxCard",
  "inboxItem": "offer-dialog-module__ayutrW__inboxItem",
  "inboxItemCopy": "offer-dialog-module__ayutrW__inboxItemCopy",
  "inboxItemHero": "offer-dialog-module__ayutrW__inboxItemHero",
  "inboxThumbnail": "offer-dialog-module__ayutrW__inboxThumbnail",
  "invoiceFeeHeader": "offer-dialog-module__ayutrW__invoiceFeeHeader",
  "invoiceFeeOption": "offer-dialog-module__ayutrW__invoiceFeeOption",
  "invoiceFeeOptions": "offer-dialog-module__ayutrW__invoiceFeeOptions",
  "itemActions": "offer-dialog-module__ayutrW__itemActions",
  "itemImage": "offer-dialog-module__ayutrW__itemImage",
  "itemInfo": "offer-dialog-module__ayutrW__itemInfo",
  "itemNameRow": "offer-dialog-module__ayutrW__itemNameRow",
  "itemOfferActions": "offer-dialog-module__ayutrW__itemOfferActions",
  "itemOfferDetails": "offer-dialog-module__ayutrW__itemOfferDetails",
  "itemOfferPanel": "offer-dialog-module__ayutrW__itemOfferPanel",
  "itemOfferSeparator": "offer-dialog-module__ayutrW__itemOfferSeparator",
  "itemOutput": "offer-dialog-module__ayutrW__itemOutput",
  "itemPlaceBid": "offer-dialog-module__ayutrW__itemPlaceBid",
  "itemPreview": "offer-dialog-module__ayutrW__itemPreview",
  "itemSummaryLabel": "offer-dialog-module__ayutrW__itemSummaryLabel",
  "liveCountdown": "offer-dialog-module__ayutrW__liveCountdown",
  "lowSale": "offer-dialog-module__ayutrW__lowSale",
  "manageOffersLink": "offer-dialog-module__ayutrW__manageOffersLink",
  "managerAmount": "offer-dialog-module__ayutrW__managerAmount",
  "managerCard": "offer-dialog-module__ayutrW__managerCard",
  "managerEmpty": "offer-dialog-module__ayutrW__managerEmpty",
  "managerGrid": "offer-dialog-module__ayutrW__managerGrid",
  "managerHeader": "offer-dialog-module__ayutrW__managerHeader",
  "messageField": "offer-dialog-module__ayutrW__messageField",
  "messageHint": "offer-dialog-module__ayutrW__messageHint",
  "mobileMinimum": "offer-dialog-module__ayutrW__mobileMinimum",
  "myItemOffers": "offer-dialog-module__ayutrW__myItemOffers",
  "narrowDialog": "offer-dialog-module__ayutrW__narrowDialog",
  "offerAction": "offer-dialog-module__ayutrW__offerAction",
  "offerAmount": "offer-dialog-module__ayutrW__offerAmount",
  "offerBanner": "offer-dialog-module__ayutrW__offerBanner",
  "offerCount": "offer-dialog-module__ayutrW__offerCount",
  "offerExpiry": "offer-dialog-module__ayutrW__offerExpiry",
  "offerListRow": "offer-dialog-module__ayutrW__offerListRow",
  "offerTabs": "offer-dialog-module__ayutrW__offerTabs",
  "overlay": "offer-dialog-module__ayutrW__overlay",
  "ownOfferBadge": "offer-dialog-module__ayutrW__ownOfferBadge",
  "proceeds": "offer-dialog-module__ayutrW__proceeds",
  "profileOffers": "offer-dialog-module__ayutrW__profileOffers",
  "progress": "offer-dialog-module__ayutrW__progress",
  "publicOfferSummary": "offer-dialog-module__ayutrW__publicOfferSummary",
  "publicOffersHeader": "offer-dialog-module__ayutrW__publicOffersHeader",
  "radioCopy": "offer-dialog-module__ayutrW__radioCopy",
  "radioRow": "offer-dialog-module__ayutrW__radioRow",
  "rebate": "offer-dialog-module__ayutrW__rebate",
  "rebateNote": "offer-dialog-module__ayutrW__rebateNote",
  "rebatePill": "offer-dialog-module__ayutrW__rebatePill",
  "receipt": "offer-dialog-module__ayutrW__receipt",
  "receiptActions": "offer-dialog-module__ayutrW__receiptActions",
  "receiptAmount": "offer-dialog-module__ayutrW__receiptAmount",
  "receiptCard": "offer-dialog-module__ayutrW__receiptCard",
  "receiptDetails": "offer-dialog-module__ayutrW__receiptDetails",
  "receiptExpiry": "offer-dialog-module__ayutrW__receiptExpiry",
  "receiptHeading": "offer-dialog-module__ayutrW__receiptHeading",
  "receiptImage": "offer-dialog-module__ayutrW__receiptImage",
  "receiptLink": "offer-dialog-module__ayutrW__receiptLink",
  "receiptTarget": "offer-dialog-module__ayutrW__receiptTarget",
  "refreshOffers": "offer-dialog-module__ayutrW__refreshOffers",
  "refundFee": "offer-dialog-module__ayutrW__refundFee",
  "rowActions": "offer-dialog-module__ayutrW__rowActions",
  "saleDanger": "offer-dialog-module__ayutrW__saleDanger",
  "saleWarning": "offer-dialog-module__ayutrW__saleWarning",
  "scopeChoices": "offer-dialog-module__ayutrW__scopeChoices",
  "section": "offer-dialog-module__ayutrW__section",
  "stats": "offer-dialog-module__ayutrW__stats",
  "submit": "offer-dialog-module__ayutrW__submit",
  "submitDanger": "offer-dialog-module__ayutrW__submitDanger",
  "tokenAmountRow": "offer-dialog-module__ayutrW__tokenAmountRow",
  "topOffer": "offer-dialog-module__ayutrW__topOffer",
  "topOfferActions": "offer-dialog-module__ayutrW__topOfferActions",
  "topOfferSell": "offer-dialog-module__ayutrW__topOfferSell",
  "traitColumn": "offer-dialog-module__ayutrW__traitColumn",
  "traitExpiryGrid": "offer-dialog-module__ayutrW__traitExpiryGrid",
  "traitGroup": "offer-dialog-module__ayutrW__traitGroup",
  "traitValue": "offer-dialog-module__ayutrW__traitValue",
  "traitValues": "offer-dialog-module__ayutrW__traitValues",
  "traits": "offer-dialog-module__ayutrW__traits",
  "unavailable": "offer-dialog-module__ayutrW__unavailable",
  "walletOffers": "offer-dialog-module__ayutrW__walletOffers",
  "warningPercent": "offer-dialog-module__ayutrW__warningPercent",
});
